import { useState, useEffect } from "react";
import { useQuery } from "react-apollo";
import { GET_MERCHANT_DETAILS } from "../graphql/queries";


export const useCustomers = () => {
    const {error, data} = useQuery(GET_MERCHANT_DETAILS);
    const [searchString, setSearchString] = useState('');
    const [matches, setMatches] = useState([]);
    
    useEffect(() => {
    const match = data && data.getMerchantDetails.customers && searchString ? data.getMerchantDetails.customers
    .filter(customer => customer?.firstName.toUpperCase()
    .includes(searchString.toUpperCase()) || 
    customer?.phone.trim().includes(searchString.trim())).filter((_, i) => i < 5): 
    [];
    setMatches(match);
    }, [data, searchString]);


    return [searchString, setSearchString, matches, error];

}
